import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { FiPlus } from 'react-icons/fi';
import CreateActivityModal from "@features/admin/activity/components/CreateActivityModal";
import ActivityTable from "@features/admin/activity/components/ActivityTable";
import RequirePermission from '@core/components/RequirePermission';
import { ACTION_CODES } from '@features/entity/types/actionCodes';
import { useScopeId } from '@core/hooks/useRouteParamId';

const ManageActivity: React.FC = () => {
    const sid = useScopeId() ?? 0;

    // State to control the visibility of the Create Activity modal
    const [showCreate, setShowCreate] = useState(false);
    // Bumped after a create/edit so the table refetches in place (no full-page reload).
    const [refreshSignal, setRefreshSignal] = useState(0);


    return (
        <Container fluid className="py-4" data-testid="manage-activity-container">
            <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4" data-testid="manage-activity-header-row">
                <div className="ntcog-page-title-block mb-0">
                    <h1 className="ntcog-page-heading mb-1" data-testid="manage-activity-title">Activities</h1>
                    <p className="text-muted mb-0" data-testid="manage-activity-description">Manage Activities</p>
                </div>
                {Number.isFinite(sid) && sid > 0 && (
                    <RequirePermission mode="section" action={ACTION_CODES.CREATE_ACTIVITY} scopeType="NATION" scopeId={sid}>
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            aria-label="Add Activity"
                            data-testid="add-activity-button"
                        >
                            <FiPlus className="me-2" />
                            New Activity
                        </Button>
                    </RequirePermission>
                )}
            </div>

            <ActivityTable
                showPagination={true}
                refreshSignal={refreshSignal}
                data-testid="activity-table"
            />

            <CreateActivityModal
                show={showCreate}
                onHide={() => setShowCreate(false)}
                onChanged={() => setRefreshSignal((s) => s + 1)}
                data-testid="create-activity-modal"
            />
        </Container>
    );
};

export default ManageActivity;
